import {PortokasseTransaction} from '@/classes/dto/warehouse-manager/response/Shipping.types';
import {PickupOrder, PickupOverview} from '@/components/warehouse-manager/shipping/pickup.helper';
import {
    CreateAnthropicApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/anthropic/CreateAnthropicApiConfiguration.request.dto';
import {
    UpdateAnthropicApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/anthropic/UpdateAnthropicApiConfiguration.request.dto';
import {
    CreateMailgunApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/mailgun/CreateMailgunApiConfiguration.request.dto';
import {
    UpdateMailgunApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/mailgun/UpdateMailgunApiConfiguration.request.dto';
import {
    CreateMicrosoft365TenantApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/microsoft-365-tenant/CreateMicrosoft365TenantApiConfiguration.request.dto';
import {
    UpdateMicrosoft365TenantApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/microsoft-365-tenant/UpdateMicrosoft365TenantApiConfiguration.request.dto';
import {
    BookingsBusinessResponse,
    BookingsServiceResponse,
    CalendarEventResponse,
    CalendarResponse,
    CreateCalendarEventRequest,
    DeleteCalendarEventRequest,
    FindCalendarEventsRequest,
    FindMicrosoft365TenantMailboxesRequest,
    Microsoft365TenantMailboxResponse,
    UpdateCalendarEventRequest,
} from '@/classes/dto/api-handler/request/microsoft-365-tenant/Microsoft365Tenant.types';
import {LeanDocument, Types} from 'mongoose';
import {API} from './api.class';
import {FindByIdOptionsRequestDto} from '@/classes/dto/_common/request/FindByIdOptions.request.dto';
import {FindApiConfigurationRequestDto} from '@/classes/dto/api-handler/request/FindApiConfiguration.request.dto';
import {ApiConfiguration, ApiConfigurationDocument} from '@/documentTypes/api-handler/ApiConfiguration';
import {
    CreateFastBillApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/fast-bill/CreateFastBillApiConfiguration.request.dto';
import {
    UpdateFastBillApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/fast-bill/UpdateFastBillApiConfiguration.request.dto';
import {
    CreateJoinApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/join/CreateJoinApiConfiguration.request.dto';
import {
    UpdateJoinApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/join/UpdateJoinApiConfiguration.request.dto';
import {
    CreateWordPressApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/word-press/CreateWordPressApiConfiguration.request.dto';
import {
    UpdateWordPressApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/word-press/UpdateWordPressApiConfiguration.request.dto';
import {GetAllCategoriesJoinRequestDto} from '@/classes/dto/api-handler/request/join/api/categories';
import {GetAllEmploymentTypesJoinRequestDto} from '@/classes/dto/api-handler/request/join/api/employmentTypes';
import {GetAllSeniorityLevelsJoinRequestDto} from '@/classes/dto/api-handler/request/join/api/seniorityLevels';
import {
    GetWordPressCategoryLikeRequestDto,
    GetWordPressCategoryRequestDto,
} from '@/classes/dto/api-handler/request/word-press/api/categories';
import {GetWordPressCategoryResponseDto} from '@/classes/dto/api-handler/response/word-press/api';
import {
    CreateInternetmarkeApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/internetmarke/CreateInternetmarkeApiConfiguration.request.dto';
import {
    UpdateInternetmarkeApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/internetmarke/UpdateInternetmarkeApiConfiguration.request.dto';
import {
    CreatePlacetelApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/placetel/CreatePlacetelApiConfiguration.request.dto';
import {
    UpdatePlacetelApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/placetel/UpdatePlacetelApiConfiguration.request.dto';
import {
    GetSipConfigByMailPlacetelResponseDto,
} from '@/classes/dto/api-handler/response/placetel/api/GetSipConfigByMail.placetel.response.dto';
import {
    GetSipConfigByMailPlacetelRequestDto,
} from '@/classes/dto/api-handler/request/placetel/api/GetSipConfigByMail.placetel.request.dto';
import {
    SetBrowserTestProfilePlacetelRequestDto,
} from '@/classes/dto/api-handler/request/placetel/api/SetBrowserTestProfile.placetel.request.dto';
import {
    BrowserTestProfilePlacetelResponseDto,
} from '@/classes/dto/api-handler/response/placetel/api/BrowserTestProfile.placetel.response.dto';
import {
    CallCenterAgentPlacetelResponseDto,
} from '@/classes/dto/api-handler/response/placetel/api/CallCenterAgent.placetel.response.dto';
import {
    SetCallCenterAgentStatusPlacetelRequestDto,
} from '@/classes/dto/api-handler/request/placetel/api/SetCallCenterAgentStatus.placetel.request.dto';
import {
    CallCenterAgentListItemPlacetelResponseDto,
} from '@/classes/dto/api-handler/response/placetel/api/CallCenterAgentListItem.placetel.response.dto';
import {
    CallCenterSchedulePlacetelResponseDto,
} from '@/classes/dto/api-handler/response/placetel/api/CallCenterSchedule.placetel.response.dto';
import {
    ApplyCallCenterSchedulePlacetelResponseDto,
} from '@/classes/dto/api-handler/response/placetel/api/ApplyCallCenterSchedule.placetel.response.dto';
import {
    SetCallCenterSchedulePlacetelRequestDto,
} from '@/classes/dto/api-handler/request/placetel/api/SetCallCenterSchedule.placetel.request.dto';
import {isAxiosError} from 'axios';
import {OpenPlacetelCallResponseDto, OwnPlacetelCallResponseDto, UpdatePlacetelCallProtocolRequestDto} from '@/components/callWindow/callWindow.types';
import {
    CreateWhatsAppApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/whats-app/CreateWhatsAppApiConfiguration.request.dto';
import {
    UpdateWhatsAppApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/whats-app/UpdateWhatsAppApiConfiguration.request.dto';
import {
    SendWhatsAppTextMessageRequestDto,
} from '@/classes/dto/api-handler/request/whats-app/api/messages/SendWhatsAppTextMessage.request.dto';
import {
    SendWhatsAppMessageResponseDto,
} from '@/classes/dto/api-handler/response/whats-app/api/SendWhatsAppMessage.response.dto';
import {
    GetWhatsAppMessagingHealthStatusResponseDto,
} from '@/classes/dto/api-handler/response/whats-app/api/GetWhatsAppMessagingHealthStatus.response.dto';
import {WhatsAppApiConfigurationDocument} from '@/documentTypes/api-handler/WhatsAppApiConfiguration';
import {
    GetWhatsAppMessageTemplatesRequestDto,
} from '@/classes/dto/api-handler/request/whats-app/api/templates/GetWhatsAppMessageTemplates.request.dto';
import {
    GetWhatsAppMessageTemplatesResponseDto,
} from '@/classes/dto/api-handler/response/whats-app/api/GetWhatsAppMessageTemplates.response.dto';
import {
    SendWhatsAppTemplateMessageRequestDto,
} from '@/classes/dto/api-handler/request/whats-app/api/messages/SendWhatsAppTemplateMessage.request.dto';
import {
    CreateMailApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/mail/CreateMailApiConfiguration.request.dto';
import {
    UpdateMailApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/mail/UpdateMailApiConfiguration.request.dto';
import {
    FindMailApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/mail/FindMailApiConfiguration.request.dto';
import {MailApiConfigurationDocument} from '@/documentTypes/api-handler/MailApiConfiguration';
import {ParsedMail} from 'mailparser';
import {GetBoxesMailResponseDto} from '@/classes/dto/api-handler/response/mail/api/GetBoxes.mail.response.dto';
import {GetBoxesMailRequestDto} from '@/classes/dto/api-handler/request/mail/api/GetBoxes.mail.request.dto';
import {
    GetImapAccessDetailsMailRequestDto,
} from '@/classes/dto/api-handler/request/mail/api/GetImapAccessDetails.mail.request.dto';
import {
    GetImapAccessDetailsMailResponseDto,
} from '@/classes/dto/api-handler/response/mail/api/GetImapAccessDetails.mail.response.dto';
import {
    GetEmailAttachmentMailRequestDto,
} from '@/classes/dto/api-handler/request/mail/api/GetEmailAttachment.mail.request.dto';
import {
    GetWhatsAppMediaRequestDto,
} from '@/classes/dto/api-handler/request/whats-app/api/messages/GetWhatsAppMedia.request.dto';
import {
    ChargeInternetmarkeWalletResponseDto,
    CreateInternetmarkeStampsResponseDto,
    GetInternetmarkeCatalogResponseDto,
    GetInternetmarkeWalletBalanceResponseDto,
} from '@/classes/dto/api-handler/response/internetmarke/api';
import {
    ChargeInternetmarkeWalletRequestDto,
    CreateInternetmarkeStampsRequestDto,
    GetInternetmarkeCatalogRequestDto,
} from '@/classes/dto/api-handler/request/internetmarke/api';
import {
    CreateInternetmarkeManualStampsRequestDto,
} from '@/classes/dto/api-handler/request/internetmarke/api/CreateInternetmarkeManualStamps.request.dto';
import {
    CreateInternetmarkeManualStampsResponseDto,
} from '@/classes/dto/api-handler/response/internetmarke/api/CreateInternetmarkeManualStamps.response.dto';
import {GetApiQueueLimitsResponseDto} from '@/classes/dto/api-handler/response/GetApiQueueLimits.response.dto';
import {GetCallsVapiRequestDto} from '@/classes/dto/api-handler/request/vapi/api/GetCalls.vapi.request.dto';
import {Assistant, PhoneNumbersListResponseItem} from '@vapi-ai/server-sdk/api';
import {
    CreateVapiApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/vapi/CreateVapiApiConfiguration.request.dto';
import {
    UpdateVapiApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/vapi/UpdateVapiApiConfiguration.request.dto';
import {GetAssistantsVapiRequestDto} from '@/classes/dto/api-handler/request/vapi/api/GetAssistants.vapi.request.dto';
import {
    CreateBatchCallVapiRequestDto,
    CreateCallVapiRequestDto,
} from '@/classes/dto/api-handler/request/vapi/api/CreateCall.vapi.request.dto';
import {
    UpdateAssistantVapiRequestDto,
} from '@/classes/dto/api-handler/request/vapi/api/UpdateAssistant.vapi.request.dto';
import {
    CreateAssistantIntegrationRequestDto,
} from '@/classes/dto/api-handler/request/vapi/assistant-integration/CreateAssistantIntegration.request.dto';
import {
    UpdateAssistantIntegrationRequestDto,
} from '@/classes/dto/api-handler/request/vapi/assistant-integration/UpdateAssistantIntegration.request.dto';
import {
    VapiAssistantIntegrationConfigDocument,
} from '@/documentTypes/api-handler/vapi-sub/VapiAssistantIntegrationConfig.document';
import {
    FindDhlProductPricingRequestDto,
} from '@/classes/dto/api-handler/request/dhl/api/dhl-pricing-api/FindDhlProductPricing.request.dto';
import {DhlProductPricingDocument} from '@/documentTypes/api-handler/dhl-sub/DhlProductPricing.document';
import {LiveTrackingResponse} from '@/components/warehouse-manager/shipping/liveTracking.helper';
import {
    CreateDhlApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/dhl/CreateDhlApiConfiguration.request.dto';
import {
    UpdateDhlApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/dhl/UpdateDhlApiConfiguration.request.dto';
import {
    GetMetaMarketingInsightsRequestDto,
} from '@/classes/dto/api-handler/request/meta-marketing/api/GetMetaMarketingInsights.request.dto';
import {
    GetMetaMarketingInsightsResponseDto,
} from '@/classes/dto/api-handler/response/meta-marketing/api/GetMetaMarketingInsights.response.dto';
import {
    UpdateMetaAdSetTargetingRequestDto,
} from '@/classes/dto/api-handler/request/meta-marketing/api/UpdateMetaAdSetTargeting.request.dto';
import {
    GetMetaMarketingCampaignsResponseDto,
} from '@/classes/dto/api-handler/response/meta-marketing/api/GetMetaMarketingCampaigns.response.dto';
import {
    UpdateMetaMarketingApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/meta-marketing/UpdateMetaMarketingApiConfiguration.request.dto';
import {
    CreateMetaMarketingApiConfigurationRequestDto,
} from '@/classes/dto/api-handler/request/meta-marketing/CreateMetaMarketingApiConfiguration.request.dto';
import {MetaMarketingApiConfigurationDocument} from '@/documentTypes/MetaMarketingApiConfiguration';
import {
    GetMetaMarketingCampaignsRequestDto,
} from '@/classes/dto/api-handler/request/meta-marketing/api/GetMetaMarketingCampaigns.request.dto';
import {
    GetMetaMarketingAdSetsRequestDto,
} from '@/classes/dto/api-handler/request/meta-marketing/api/GetMetaMarketingAdSet.request.dto';
import {
    GetMetaMarketingAdSetsResponseDto,
} from '@/classes/dto/api-handler/response/meta-marketing/api/GetMetaMarketingAdSets.response.dto';
import {PaginationResponseType} from '@/types/common/paginationResponseType';
import {CrudEntityTypes} from '@/classes/clientOnly/permissionTreeResources/enums/CrudEntityTypes';
import {VapiCallDocument} from '@/documentTypes/api-handler/vapi-sub/VapiCall.document';


/**
 * This class is used for communicating with the api-handler microservice.
 * @class ApiHandlerApi
 * @author Joshua Seipel
 */
export class ApiHandlerApi extends API {
    static service = 'api-handler';
    static dhl = {
        api: {
            pricing: {
                find: async (data: FindDhlProductPricingRequestDto): Promise<{
                    products: LeanDocument<DhlProductPricingDocument>[];
                    maxPage: number
                }> => {
                    return this.get(`dhl-pricing-api/pricing`, data);
                },
                findById: async (id: Types.ObjectId | string, options?: FindByIdOptionsRequestDto): Promise<{
                    products: LeanDocument<DhlProductPricingDocument>[];
                    maxPage: number
                }> => {
                    return this.get(`dhl-pricing-api/pricing/${id}`, options);
                },
            },
            shipment: {
                canAccess: async (): Promise<boolean> => {
                    return this.get(`dhl-shipment-api/can-access`);
                },
            },
            retoure: {
                canAccess: async (): Promise<boolean> => {
                    return this.get(`dhl-retoure-api/can-access`);
                },
            },
            tracking: {
                /** Live-Stand offener DHL-Sendungen (höchstens alle 15 Minuten je Sendung bei DHL abgefragt, max. 40) */
                refresh: async (productShipments: Array<Types.ObjectId | string>): Promise<LiveTrackingResponse> => {
                    return this.post(`dhl-tracking-api/refresh`, {productShipments});
                },
            },
            pickup: {
                /** Abholung: Büro/Abholort, buchbare Tage, gebuchte Abholungen, wartende Pakete mit Termin, Laufzeiten */
                overview: async (): Promise<PickupOverview> => {
                    return this.get(`dhl-pickup-api/overview`);
                },
                create: async (data: { pickupDay: string; productShipments: string[]; extraParcels?: number; containers?: Array<{ type: string; count: number }>; comment?: string }): Promise<PickupOrder> => {
                    return this.post(`dhl-pickup-api/pickups`, data);
                },
                /** Pakete nachträglich hinzufügen (vor der Frist tauscht Vanilla den DHL-Auftrag, danach nur vermerkt) */
                add: async (id: string, data: { productShipments: string[]; extraParcels?: number }): Promise<PickupOrder & { replaced: boolean }> => {
                    return this.post(`dhl-pickup-api/pickups/${id}/add`, data);
                },
                /** Stand sofort bei DHL nachfragen (sonst stündlich) */
                refresh: async (id: string): Promise<PickupOrder> => {
                    return this.post(`dhl-pickup-api/pickups/${id}/refresh`, {});
                },
                cancel: async (id: string): Promise<PickupOrder> => {
                    return this.delete(`dhl-pickup-api/pickups/${id}`);
                },
            },
        },
        create: async (data: CreateDhlApiConfigurationRequestDto): Promise<Types.ObjectId> => {
            return this.post(`dhl`, data);
        },
        update: async (id: Types.ObjectId, data: UpdateDhlApiConfigurationRequestDto) => {
            return this.put(`dhl/${id}`, data);
        },
    };
    static mail = {
        create: async (data: CreateMailApiConfigurationRequestDto): Promise<Types.ObjectId> => {
            return this.post(`mail`, data);
        },
        update: async (id: Types.ObjectId, data: UpdateMailApiConfigurationRequestDto) => {
            return this.put(`mail/${id}`, data);
        },
        find: async (data: FindMailApiConfigurationRequestDto): Promise<{
            mailApiConfigurations: LeanDocument<MailApiConfigurationDocument>[];
            maxPage: number
        }> => {
            return this.get(`mail/find`, data);
        },
        api: {
            getMails: async (id: Types.ObjectId): Promise<ParsedMail[]> => {
                return this.get(`mail-api/mails/${id}`);
            },
            getBoxes: async (id: Types.ObjectId, query?: GetBoxesMailRequestDto): Promise<GetBoxesMailResponseDto> => {
                return this.get(`mail-api/boxes/${id}`, query);
            },
            getImapAccessDetails: async (data: GetImapAccessDetailsMailRequestDto): Promise<GetImapAccessDetailsMailResponseDto[]> => {
                return this.get(`mail-api/imap-access-details`, data);
            },
            getImapAccessDetailsById: async (id: Types.ObjectId): Promise<GetImapAccessDetailsMailResponseDto> => {
                return this.get(`mail-api/imap-access-details/${id}`);
            },
            getAttachment: async (data: GetEmailAttachmentMailRequestDto): Promise<Blob> => {
                return this.get(`mail-api/attachment/${data.username}/${data.box}/${data.uid}/${data.filename}`, {}, 'blob');
            },
        },
    }
    static whatsApp = {
        create: async (data: CreateWhatsAppApiConfigurationRequestDto) => {
            return this.post(`whats-app`, data);
        },
        update: async (id: Types.ObjectId, data: UpdateWhatsAppApiConfigurationRequestDto) => {
            return this.put(`whats-app/${id}`, data);
        },
        find: async (data: FindApiConfigurationRequestDto): Promise<{
            whatsAppApiConfigurations: LeanDocument<WhatsAppApiConfigurationDocument>[];
            maxPage: number
        }> => {
            return this.get(`whats-app/find`, data);
        },
        api: {
            healthStatus: async (id: Types.ObjectId): Promise<GetWhatsAppMessagingHealthStatusResponseDto> => {
                return this.get(`whats-app-api/health-status/${id}`);
            },
            sendTextMessage: async (id: Types.ObjectId, data: SendWhatsAppTextMessageRequestDto): Promise<SendWhatsAppMessageResponseDto> => {
                return this.post(`whats-app-api/send-message/text/${id}`, data);
            },
            sendTemplateMessage: async (id: Types.ObjectId, data: SendWhatsAppTemplateMessageRequestDto): Promise<SendWhatsAppMessageResponseDto> => {
                return this.post(`whats-app-api/send-message/template/${id}`, data);
            },
            getMessageTemplates: async (id: Types.ObjectId, data: GetWhatsAppMessageTemplatesRequestDto): Promise<GetWhatsAppMessageTemplatesResponseDto> => {
                return this.get(`whats-app-api/message-templates/${id}`, data);
            },
            getMedia: async (data: GetWhatsAppMediaRequestDto): Promise<Blob> => {
                return this.get(`whats-app-api/media/${data.phoneNumberId}/${data.mediaId}`, {}, 'blob');
            },
        },
    }
    static metaMarketing = {
        create: async (data: CreateMetaMarketingApiConfigurationRequestDto): Promise<Types.ObjectId> => {
            return this.post(`meta-marketing`, data);
        },
        update: async (id: Types.ObjectId, data: UpdateMetaMarketingApiConfigurationRequestDto): Promise<Types.ObjectId> => {
            return this.put(`meta-marketing/${id}`, data);
        },
        find: async (data: FindApiConfigurationRequestDto): Promise<{
            metaMarketingApiConfigurations: LeanDocument<MetaMarketingApiConfigurationDocument>[];
            maxPage: number;
        }> => {
            return this.get(`meta-marketing/find`, data);
        },
        api: {
            /**
             * Kampagnen abrufen
             * GET /meta-marketing-api/campaigns/:id
             */
            getCampaigns: async (id: Types.ObjectId, data: GetMetaMarketingCampaignsRequestDto): Promise<GetMetaMarketingCampaignsResponseDto> => {
                return this.get(`meta-marketing-api/campaigns/${id}`, data);
            },

            getAdSets: async (id: Types.ObjectId, data: GetMetaMarketingAdSetsRequestDto): Promise<GetMetaMarketingAdSetsResponseDto> => {
                return this.get(`meta-marketing-api/adset/${id}`, data);
            },

            /**
             * Insights abrufen
             * GET /meta-marketing-api/insights/:id
             */
            getInsights: async (
                id: Types.ObjectId,
                data: GetMetaMarketingInsightsRequestDto,
            ): Promise<GetMetaMarketingInsightsResponseDto> => {
                return this.get(`meta-marketing-api/insights/${id}`, data);
            },

            /**
             * PLZ-Targeting aktualisieren
             * PUT /meta-marketing-api/adset/targeting/:id
             */
            updateAdSetTargeting: async (
                id: Types.ObjectId,
                data: UpdateMetaAdSetTargetingRequestDto,
            ): Promise<{ success: boolean; id?: string }> => {
                return this.put(`meta-marketing-api/adset/targeting/${id}`, data);
            },
        },
    };
    static internetmarke = {
        create: async (data: CreateInternetmarkeApiConfigurationRequestDto) => {
            return this.post(`internetmarke`, data);
        },
        update: async (id: Types.ObjectId, data: UpdateInternetmarkeApiConfigurationRequestDto) => {
            return this.put(`internetmarke/${id}`, data);
        },
        api: {
            canAccess: async (): Promise<boolean> => {
                return this.get(`internetmarke-api/can-access`);
            },
            /** Kauf, Aufladen und Erstattung sind nur auf Produktion erlaubt (Testing: nur mit ausdrücklicher Freigabe) */
            purchaseAllowed: async (): Promise<{ allowed: boolean; env?: string }> => {
                return this.get(`internetmarke-api/purchase-allowed`);
            },
            /** Offene Erstattungen sofort bei der Post abfragen */
            checkRefunds: async (): Promise<{ checked: number }> => {
                return this.post(`internetmarke-api/refunds/check`, {});
            },
            getBalance: async (): Promise<GetInternetmarkeWalletBalanceResponseDto> => {
                return this.get(`internetmarke-api/balance`);
            },
            /** Verlauf der Portokasse (Aufladungen/Käufe aus Vanilla mit Person) */
            getTransactions: async (limit = 20): Promise<{transactions: PortokasseTransaction[]}> => {
                return this.get(`internetmarke-api/transactions`, {limit});
            },
            chargeWallet: async (data: ChargeInternetmarkeWalletRequestDto): Promise<ChargeInternetmarkeWalletResponseDto> => {
                return this.put(`internetmarke-api/charge-wallet`, data);
            },
            getCatalog: async (data: GetInternetmarkeCatalogRequestDto): Promise<GetInternetmarkeCatalogResponseDto> => {
                return this.get(`internetmarke-api/catalog`, data);
            },
            createStamps: async (data: CreateInternetmarkeStampsRequestDto): Promise<CreateInternetmarkeStampsResponseDto> => {
                return this.post(`internetmarke-api/create-stamps`, data);
            },
            createStampsManual: async (data: CreateInternetmarkeManualStampsRequestDto): Promise<CreateInternetmarkeManualStampsResponseDto> => {
                return this.post(`internetmarke-api/create-stamps-manual`, data);
            },
        },
    }
    static fastBill = {
        create: async (data: CreateFastBillApiConfigurationRequestDto) => {
            return this.post(`fast-bill`, data);
        },
        update: async (id: Types.ObjectId, data: UpdateFastBillApiConfigurationRequestDto) => {
            return this.put(`fast-bill/${id}`, data);
        },
        api: {
            getLimits: async (): Promise<GetApiQueueLimitsResponseDto> => {
                return this.get(`fast-bill-api/queue-limits`);
            },
        },
    }
    static placetel = {
        create: async (data: CreatePlacetelApiConfigurationRequestDto) => {
            return this.post('placetel', data);
        },
        update: async (id: Types.ObjectId, data: UpdatePlacetelApiConfigurationRequestDto) => {
            return this.put(`placetel/${id}`, data);
        },
        api: {
            getSipConfigByMail: async (data: GetSipConfigByMailPlacetelRequestDto): Promise<GetSipConfigByMailPlacetelResponseDto> => {
                return this.get(`placetel-api/sip-config-by-mail/${data.email}`)
            },
            getBrowserTestProfile: async (): Promise<BrowserTestProfilePlacetelResponseDto | null> => {
                return this.get(`placetel-api/browser-test-profile`);
            },
            setBrowserTestProfile: async (data: SetBrowserTestProfilePlacetelRequestDto): Promise<BrowserTestProfilePlacetelResponseDto> => {
                return this.put(`placetel-api/browser-test-profile`, data);
            },
            clearBrowserTestProfile: async (): Promise<void> => {
                return this.delete(`placetel-api/browser-test-profile`);
            },
            /** Eigener Call-Center-Agent, null wenn für den Nutzer keiner eingerichtet ist (404) */
            getCallCenterAgent: async (): Promise<CallCenterAgentPlacetelResponseDto | null> => {
                try {
                    return await this.get(`placetel-api/call-center-agent`);
                } catch (e) {
                    if (isAxiosError(e) && e.response?.status === 404) {
                        return null;
                    }
                    throw e;
                }
            },
            /** Setzt den Status des eigenen Agents, die Antwort enthält bereits den neuen Status */
            setCallCenterAgentStatus: async (data: SetCallCenterAgentStatusPlacetelRequestDto): Promise<CallCenterAgentPlacetelResponseDto> => {
                return this.put(`placetel-api/call-center-agent/status`, data);
            },
            /** Alle Agents des Placetel-Accounts für die Dienstplan-Auswahl (Berechtigung managePlacetelSchedule) */
            getCallCenterAgents: async (): Promise<CallCenterAgentListItemPlacetelResponseDto[]> => {
                return this.get(`placetel-api/call-center-agents`);
            },
            /** Wochenplan, updatedAt ist null solange keiner gespeichert wurde */
            getCallCenterSchedule: async (): Promise<CallCenterSchedulePlacetelResponseDto> => {
                return this.get(`placetel-api/call-center-schedule`);
            },
            /** Ersetzt den kompletten Plan, wirkt erst beim nächsten Dienstwechsel. 422 bei unbekannten Agent-IDs */
            setCallCenterSchedule: async (data: SetCallCenterSchedulePlacetelRequestDto): Promise<CallCenterSchedulePlacetelResponseDto> => {
                return this.put(`placetel-api/call-center-schedule`, data);
            },
            /** Setzt den gerade gültigen Dienst sofort um. 404 solange kein Plan gespeichert ist */
            applyCallCenterSchedule: async (): Promise<ApplyCallCenterSchedulePlacetelResponseDto> => {
                return this.post(`placetel-api/call-center-schedule/apply`, {});
            },
            /** Anruf-Fenster: eigene beendete Anrufe der letzten Tage ohne Protokoll (inkl. verpasster Rückrufe) */
            getOpenCalls: async (): Promise<OpenPlacetelCallResponseDto[]> => {
                return this.get(`placetel-api/calls/open`);
            },
            /** Meine Anrufe: eigene Anrufe und verpasste Rückrufe, neueste zuerst (before = weiterblättern) */
            getOwnCalls: async (data: { filter?: string; before?: Date | string; limit?: number }): Promise<OwnPlacetelCallResponseDto[]> => {
                return this.get(`placetel-api/calls/mine`, data);
            },
            /** Anruf-Fenster: Protokoll gespeichert oder „kein Protokoll nötig“ */
            setCallProtocol: async (id: Types.ObjectId | string, data: UpdatePlacetelCallProtocolRequestDto): Promise<void> => {
                return this.put(`placetel-api/calls/${id}/protocol`, data);
            },
        },
    }
    static join = {
        create: async (data: CreateJoinApiConfigurationRequestDto) => {
            return this.post(`join`, data);
        },
        update: async (id: Types.ObjectId, data: UpdateJoinApiConfigurationRequestDto) => {
            return this.put(`join/${id}`, data);
        },
        api: {
            getCategories: async (data: GetAllCategoriesJoinRequestDto) => {
                return this.get(`join-api/categories`, data);
            },
            getEmploymentTypes: async (data: GetAllEmploymentTypesJoinRequestDto) => {
                return this.get(`join-api/employment-types`, data);
            },
            getSeniorityLevels: async (data: GetAllSeniorityLevelsJoinRequestDto) => {
                return this.get(`join-api/seniority-levels`, data);
            },
            getJobCount: async () => {
                return this.get(`join-api/job-count`);
            },
            getApplication: async (id: number) => {
                return this.get(`join-api/applications/${id}`);
            },
        },
    }
    static anthropic = {
        create: async (data: CreateAnthropicApiConfigurationRequestDto): Promise<Types.ObjectId> => {
            return this.post(`anthropic`, data);
        },
        update: async (id: Types.ObjectId, data: UpdateAnthropicApiConfigurationRequestDto): Promise<Types.ObjectId> => {
            return this.put(`anthropic/${id}`, data);
        },
    };

    /** Mailgun domain for automatic mails without a conversation (the services send through the api-handler directly) */
    static mailgun = {
        create: async (data: CreateMailgunApiConfigurationRequestDto): Promise<Types.ObjectId> => {
            return this.post(`mailgun`, data);
        },
        update: async (id: Types.ObjectId, data: UpdateMailgunApiConfigurationRequestDto): Promise<Types.ObjectId> => {
            return this.put(`mailgun/${id}`, data);
        },
    };

    /** Microsoft 365 Organisation: mailboxes are used through `mail`/`mail-api`, calendars and Bookings pages live here */
    static microsoft365Tenant = {
        /** Bookings pages of the organisation, chosen per acquisition list (needs permission on acquisition lists) */
        bookings: {
            businesses: {
                find: async (): Promise<BookingsBusinessResponse[]> => {
                    return this.get(`microsoft-365-tenant/bookings/businesses`);
                },
                services: async (businessId: string): Promise<BookingsServiceResponse[]> => {
                    return this.get(`microsoft-365-tenant/bookings/businesses/${encodeURIComponent(businessId)}/services`);
                },
            },
        },
        create: async (data: CreateMicrosoft365TenantApiConfigurationRequestDto): Promise<Types.ObjectId> => {
            return this.post(`microsoft-365-tenant`, data);
        },
        update: async (id: Types.ObjectId, data: UpdateMicrosoft365TenantApiConfigurationRequestDto): Promise<Types.ObjectId> => {
            return this.put(`microsoft-365-tenant/${id}`, data);
        },
        refreshMailboxes: async (id: Types.ObjectId): Promise<{ mailboxes: number; mailboxesSyncedAt: string }> => {
            return this.post(`microsoft-365-tenant/${id}/mailboxes/refresh`, {});
        },
        mailboxes: {
            find: async (data: FindMicrosoft365TenantMailboxesRequest = {}): Promise<Microsoft365TenantMailboxResponse[]> => {
                return this.get(`microsoft-365-tenant/mailboxes`, data);
            },
        },
        calendars: {
            find: async (mailbox: string): Promise<CalendarResponse[]> => {
                return this.get(`microsoft-365-tenant/calendars`, {mailbox});
            },
            events: {
                find: async (data: FindCalendarEventsRequest): Promise<CalendarEventResponse[]> => {
                    return this.get(`microsoft-365-tenant/calendars/events`, data);
                },
                create: async (data: CreateCalendarEventRequest): Promise<CalendarEventResponse> => {
                    return this.post(`microsoft-365-tenant/calendars/events`, data);
                },
                update: async (data: UpdateCalendarEventRequest): Promise<CalendarEventResponse> => {
                    return this.put(`microsoft-365-tenant/calendars/events`, data);
                },
                delete: async (data: DeleteCalendarEventRequest): Promise<{ success: boolean }> => {
                    return this.delete(`microsoft-365-tenant/calendars/events`, data);
                },
            },
        },
    };
    static vapi = {
        create: async (data: CreateVapiApiConfigurationRequestDto): Promise<Types.ObjectId> => {
            return this.post(`vapi`, data);
        },
        update: async (id: Types.ObjectId, data: UpdateVapiApiConfigurationRequestDto): Promise<Types.ObjectId> => {
            return this.put(`vapi/${id}`, data);
        },
        assistantIntegration: {
            createConfig: async (data: CreateAssistantIntegrationRequestDto): Promise<Types.ObjectId> => {
                return this.post(`vapi-assistant-integration`, data);
            },
            updateConfig: async (id: Types.ObjectId, data: UpdateAssistantIntegrationRequestDto): Promise<Types.ObjectId> => {
                return this.put(`vapi-assistant-integration/${id}`, data);
            },
            findByAssistantId: async (assistantId: string): Promise<LeanDocument<VapiAssistantIntegrationConfigDocument>> => {
                return this.get(`vapi-assistant-integration/assistantId/${assistantId}`);
            },
            findById: async (id: Types.ObjectId): Promise<LeanDocument<VapiAssistantIntegrationConfigDocument>> => {
                return this.get(`vapi-assistant-integration/${id}`);
            },
        },
        api: {
            canAccess: async (): Promise<boolean> => {
                return this.get(`vapi-api/can-access`);
            },
            createCall: async (data: CreateCallVapiRequestDto): Promise<string> => {
                return this.post(`vapi-api/call`, data);
            },
            createBatchCall: async (data: CreateBatchCallVapiRequestDto): Promise<string> => {
                return this.post(`vapi-api/batch-call`, data);
            },
            getCalls: async (data: GetCallsVapiRequestDto): Promise<PaginationResponseType<CrudEntityTypes.VAPI_CALL, VapiCallDocument>> => {
                return this.get(`vapi-api/calls`, data);
            },
            getAssistant: async (id: string): Promise<Assistant> => {
                return this.get(`vapi-api/assistants/${id}`);
            },
            getAssistants: async (data: GetAssistantsVapiRequestDto): Promise<{ assistants: Assistant[] }> => {
                return this.get(`vapi-api/assistants`, data);
            },
            updateAssistant: async (id: string, update: UpdateAssistantVapiRequestDto): Promise<string> => {
                return this.put(`vapi-api/assistants/${id}`, update);
            },
            getPhoneNumbers: async (data: GetAssistantsVapiRequestDto): Promise<{
                phoneNumbers: PhoneNumbersListResponseItem[]
            }> => {
                return this.get(`vapi-api/phoneNumbers`, data);
            },
        },
    }
    static wordPress = {
        create: async (data: CreateWordPressApiConfigurationRequestDto) => {
            return this.post(`word-press`, data);
        },
        update: async (id: Types.ObjectId, data: UpdateWordPressApiConfigurationRequestDto) => {
            return this.put(`word-press/${id}`, data);
        },
        api: {
            categories: {
                get: async (data: GetWordPressCategoryRequestDto): Promise<GetWordPressCategoryResponseDto[]> => {
                    return this.get(`word-press-api/categories`, data);
                },
            },
            categoryLikes: {
                get: async (data: GetWordPressCategoryLikeRequestDto): Promise<GetWordPressCategoryResponseDto[]> => {
                    return this.get(`word-press-api/category-likes`, data);
                },
            },
        },
    }

    static async find<T = ApiConfigurationDocument>(c: FindApiConfigurationRequestDto): Promise<{
        apiConfigurations: LeanDocument<T>[];
        maxPage: number
    }> {
        return this.get(``, c);
    }

    static async findById(id: Types.ObjectId, options?: FindByIdOptionsRequestDto): Promise<LeanDocument<ApiConfiguration>> {
        return this.get(`${id}`, options);
    }

    /** Deletes the configuration and closes its queue (requires delete permission for API configurations) */
    static async remove(id: Types.ObjectId): Promise<void> {
        return this.delete(`${id}`);
    }
}
